import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import Button from 'flarum/common/components/Button';
import { PREF, readPref, savePrefs, nowSeconds } from '../utils/preferences';

const t = (key, params) => app.translator.trans(`happydigital-notification-settings.forum.pause.${key}`, params);

const SNOOZE_OPTIONS = [
  { key: 'snooze_10m', minutes: 10 },
  { key: 'snooze_1h', minutes: 60 },
  { key: 'snooze_8h', minutes: 480 },
];

// Re-render while snoozed so the page flips back once the snooze expires.
const TICK_MS = 30 * 1000;

/**
 * "Pause all" switch plus temporary snooze buttons.
 *
 * Attrs: `user`
 */
export default class PauseSettings extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = null;
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    this.timer = setInterval(() => m.redraw(), TICK_MS);
  }

  onremove(vnode) {
    super.onremove(vnode);

    clearInterval(this.timer);
  }

  view() {
    const user = this.attrs.user;
    const snoozeUntil = Number(readPref(user, PREF.snoozeUntil, 0));
    const snoozed = snoozeUntil > nowSeconds();

    return (
      <div>
        <div className="Form-group">
          <Switch
            state={!!readPref(user, PREF.pauseAll, false)}
            loading={this.loading === 'pauseAll'}
            onchange={(value) => this.save('pauseAll', { [PREF.pauseAll]: value })}
          >
            {t('pause_all_label')}
          </Switch>
          <p className="helpText">{t('pause_all_help')}</p>
        </div>
        <div className="Form-group HappyNotify-snooze">{snoozed ? this.snoozedView(snoozeUntil) : this.snoozeButtons()}</div>
      </div>
    );
  }

  snoozeButtons() {
    return (
      <div className="Form-group">
        <label>{t('snooze_label')}</label>
        <div className="ButtonGroup">
          {SNOOZE_OPTIONS.map((option) => (
            <Button
              className="Button"
              loading={this.loading === option.key}
              disabled={!!this.loading}
              onclick={() => this.save(option.key, { [PREF.snoozeUntil]: nowSeconds() + option.minutes * 60 })}
            >
              {t(option.key)}
            </Button>
          ))}
        </div>
      </div>
    );
  }

  snoozedView(snoozeUntil) {
    const until = dayjs.unix(snoozeUntil);
    const time = until.isSame(dayjs(), 'day') ? until.format('HH:mm') : until.format('D MMM HH:mm');

    return [
      <p className="helpText">{t('snooze_active', { time })}</p>,
      <Button
        className="Button"
        icon="fas fa-bell"
        loading={this.loading === 'unsnooze'}
        onclick={() => this.save('unsnooze', { [PREF.snoozeUntil]: 0 })}
      >
        {t('snooze_cancel')}
      </Button>,
    ];
  }

  save(loadingKey, changes) {
    this.loading = loadingKey;

    // The save response carries the refreshed happyNotifyIsQuiet attribute.
    savePrefs(this.attrs.user, changes).finally(() => {
      this.loading = null;
      m.redraw();
    });
  }
}
